export default __webpack_public_path__ + "static/media/elementos-circulo-rayas.02a88536.svg";